import { FormControlLabel, Checkbox, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

const CheckboxLabel = ({
    control,
    label,
    sx,
}: {
    control: React.ReactElement;
    label: ReactNode;
    sx?: SxProps<Theme>;
}) => (
    <FormControlLabel
        sx={{
            m: 0,
            "&.MuiFormControlLabel-root": {
                display: "flex",
                alignItems: "center",
            },
            "& .MuiTypography-root": {
                fontSize: 14,
                letterSpacing: 0.25,
            },
            "& .MuiCheckbox-root": {
                padding: 0,
                mr: 0.5,
            },
            ...sx,
        }}
        control={control}
        label={label}
    />
);

export default CheckboxLabel;
